// Mediathek (/mediathek/): "Mehr laden" ([data-video-more] = link to the next archive page) fetches that page and appends its
// cards to [data-video-grid] in place – without JS the link simply opens page 2. Same origin only, no third-party request.
import { qs, on, t } from './dom.js';

export function initMediathek() {
  on(document, 'click', '[data-video-more]', async (e, link) => {
    const grid = qs('[data-video-grid]');
    if (!grid || !link.href || new URL(link.href, location.href).origin !== location.origin) return;
    e.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy', 'true');
    const label = link.textContent;
    link.textContent = t('mediathek.loading');
    try {
      const res = await fetch(link.href, { credentials: 'same-origin', headers: { 'X-Requested-With': 'fetch' } });
      if (!res.ok) throw new Error(String(res.status));
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const next = qs('[data-video-grid]', doc);
      const first = next ? next.firstElementChild : null;
      if (next) Array.from(next.children).forEach((card) => grid.appendChild(document.adoptNode(card)));
      const more = qs('[data-video-more]', doc);
      if (more) {
        link.href = more.getAttribute('href');
        link.textContent = label;
        link.removeAttribute('aria-busy');
      } else {
        link.closest('[data-video-more-wrap]')?.remove();
      }
      // Keyboard users: continue at the first new card.
      const id = first && first.getAttribute('data-video-card');
      const added = id ? grid.querySelector(`[data-video-card="${CSS.escape(id)}"] a`) : null;
      if (added) added.focus({ preventScroll: true });
    } catch {
      window.location.href = link.href; // fall back to the plain page link
    }
  });
}
